import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceGetNotice(params) {
    return await postRequest('notices', params);
}

export async function serviceGetNoticeDetails(params) {
    return await postRequest('notices/detail', params);
}

export async function serviceCreateNotice(params) {
    return await formDataRequest('notices/create', params);
}

export async function serviceUpdateNotice(params) {
    return await formDataRequest('notices/update', params);
}

export async function serviceDeleteNotice(params) {
    return await formDataRequest('notices/delete', params);
}
